import axios from 'axios'
import store from './../../../store/index.js'

const BASE_URL = store.state.api.baseUrl
const headers = { Authorization : `Bearer ${store.state.user.attributes.token}` }

function getpdfContracts () {
    const URI = `${BASE_URL}/api/pdfContracts`
    return axios.get(URI, { headers })
}

function updatePdfContract (pFormdata, pIdContract) {
    const URI = `${BASE_URL}/api/pdfContracts/${pIdContract}`
    return axios.post(URI, pFormdata, { headers })
}

export {
    getpdfContracts,
    updatePdfContract
}